import { render } from "./AddChildPage.vue?vue&type=template&id=b1026e12"
import script from "./AddChildPage.vue?vue&type=script&lang=js"
export * from "./AddChildPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.10.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__